// MobileSidebar.js
import React from "react";
import {  useLocation } from "react-router-dom";


const MobileSidebar = ({ handleLogout, token, userDetails }) => {
  const location = useLocation();

  const handleLogoutClick = () => {
    handleLogout();
  };

  return (
    <div className="absolute left-0 top-0 h-full ">
      {token ? (
        <div className="bg-white w-64 shadow-lg p-4 h-screen z-50">
          <div className=" flex items-center space-x-4">
            <img
              className="h-12 w-12 rounded-full"
              src={userDetails.profileImageUrl}
              alt="Profile"
            />
            <div className="flex flex-col">
              <p className="text-lg font-medium">{userDetails.name}</p>
              <p className="text-gray-500 text-sm">{userDetails.email}</p>
            </div>
          </div>
          <hr className="my-2" />
          <ul className="space-y-2">
            <li>
              <a
                href="/userprofile"
                className={`${
                  location.pathname === "/userprofile" ? "text-blue-600" : ""
                }`}
              >
                Profile
              </a>
            </li>
            <li>
              <a
                href="/usersession"
                className={`${
                  location.pathname === "/usersession" ? "text-blue-600" : ""
                }`}
              >
                Session
              </a>
            </li>
            <button onClick={handleLogoutClick}>Logout</button>
          </ul>
          <hr className="my-2" />
          <ul className="space-y-2">
            <li
              className={`${
                location.pathname === "/home" ? "text-blue-600" : ""
              }`}
            >
              <a href="/home">Home</a>
            </li>
            <li
              className={`${
                location.pathname === "/magicAI"
                  ? "text-blue-600 "
                  : "font-titillium-web text-xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-rose-900 via-red-400 to-indigo-600"
              }`}
            >
              <a href="/magicAI">MagicAI</a>
            </li>
            <li
              className={`${
                location.pathname === "/notification" ? "text-blue-600" : ""
              }`}
            >
              <a href="/notifications"> Notification</a>
            </li>
          </ul>
        </div>
      ) : (
        <div className="bg-white w-64 shadow-lg p-4 h-screen">
          <ul className="flex flex-col text-lg mt-5 ml-5 space-y-10">
            <li>
              <li
                className={`${
                  location.pathname === "/magicAI"
                    ? "text-blue-600"
                    : "font-titillium-web text-xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-rose-900 via-red-400 to-indigo-600"
                }`}
              >
                <a href="/magicAI">MagicAI</a>
              </li>
            </li>
            <li>
              <a
                href="/userlogin"
                className=" border border-cyan-500  px-5 py-3 rounded-lg  hover:font-semibold"
              >
                Login
              </a>
            </li>
            <li>
              <a
                href="/usersignup"
                className=" px-5 py-3 rounded-lg bg-gradient-to-r from-sky-400 to-indigo-600 text-white  hover:from-indigo-600 hover:to-sky-400 transition-colors duration-300"
              >
                Sign up
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default MobileSidebar;
